module.exports = __webpack_public_path__ + "img/two.ac28e289.svg";